import {Map} from 'immutable';
import React from 'react';
import {connect} from 'react-redux';
import * as actionCreators from './actions';

export class PartyDetails extends React.Component {

    constructor(props) {
        super();
        this.state = {...props};
        this.boundFocusHandler = this.focusHandler.bind(this);
    }

    focusHandler(e) {
        this.props.openPartyDetailsOverlay();
        document.documentElement.style.maxHeight = '100vh';
        document.documentElement.style.overflow = 'hidden';
        e.target.blur();
    }

    render() {
        return (
            <div className={'party-details'}>
                <input type={'input'}
                       id="party-details-makeup"
                       onFocus={this.boundFocusHandler}
                       className={'input booking-input__input party-details__input-field'}
                       readOnly
                       /*in ${this.props.numberOfRooms} apartment${this.props.numberOfRooms > 1 ? 's' : ''} / room${this.props.numberOfRooms > 1 ? 's' : ''} USE THIS WHEN THEY WANT MULTIPLE BOOKINGS RE-ADDING*/
                       value={`${this.props.totalAdults} adult${this.props.totalAdults > 1 ? 's' : ''}${this.props.totalChildren > 0 ? `, ${this.props.totalChildren} child${this.props.totalChildren !== 1 ? 'ren' : ''}` : ''}.`}/>
            </div>
        );
    }
}

export default connect((stateMap, ownProps) => {
    const state = stateMap.get('partyDetails', Map({}));
    const numberOfRooms = state.get('numberOfRooms', 0);
    let totalChildren = 0;
    let totalAdults = 0;

    for (let i = 0; i < numberOfRooms; i++) {
        totalAdults += state.getIn(['rooms', i, 'adults']);
        totalChildren += state.getIn(['rooms', i, 'children']);
    }
    return {
        numberOfRooms,
        totalAdults,
        totalChildren
    };
}, actionCreators)(PartyDetails);
